import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admininventario',
  templateUrl: './admininventario.component.html',
  styleUrls: ['./admininventario.component.scss']
})
export class AdmininventarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
